import { Injectable } from '@angular/core';
import { ReportingImportSseEventPayload } from '@api-types/sse/event-payloads/reporting-import.sse-event-payload';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReportingImportEventService {
  private readonly importFinished$ =
    new Subject<ReportingImportSseEventPayload>();

  readonly events$ = this.importFinished$.asObservable();

  emit(payload: ReportingImportSseEventPayload): void {
    this.importFinished$.next(payload);
  }
}
